import React from 'react'
import { observer } from 'mobx-react'
import classnames from 'classnames'
import UserShapefileShapeListItem from './UserShapefileShapeListItem'

const UserShapefileShapeList = ({
  userShapefileList, shapefile, level
}) => {
  if (!level) return null
  const shapes = level.shapes || []
  return (
    <ul className={classnames('shape-level-pane__list-items', {
      'flex-grow': true,
      loading: level.loading
    })}
    >
      {
        shapes.map(shape => (
          <UserShapefileShapeListItem
            key={shape.id}
            userShapefileList={userShapefileList}
            shape={shape}
          />
        ))
      }
    </ul>
  )
}

export default observer(UserShapefileShapeList)
